import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { useProjectVolumes } from '../../../../hooks/useProjectVolumes';
import { VolumeDocumentEditor } from '../volume/VolumeDocumentEditor';
/**
 * V2 Volume Workspace.
 *
 * Routing priority:
 *   1. If the volume has linked shirohige documents → OnlyOffice editor
 *   2. Fall back to legacy kind-based routing (prose/workbook/template)
 *      for volumes that haven't been linked yet.
 *
 * Routes:
 *   /proposal/:id/v2/volume/:volumeId
 *   /proposal/:id/v2/volume/:volumeId/section/:sectionId
 */ export function VolumeWorkspacePage() {
    const { id, volumeId } = useParams();
    const volumes = useProjectVolumes(id);
    if (!id || !volumeId) return null;
    const volume = (volumes.data ?? []).find((v)=>v.volumeId === volumeId);
    if (volumes.isLoading && !volume) {
        return /*#__PURE__*/ _jsx("div", {
            className: "flex h-full items-center justify-center text-sm text-slate-500",
            children: "Loading volume..."
        });
    }
    if (!volumes.isLoading && !volume) {
        return /*#__PURE__*/ _jsx("div", {
            className: "flex h-full items-center justify-center text-sm text-rose-600",
            children: "Volume not found."
        });
    }
    if (!volume) return null;
    // Primary path: OnlyOffice editor via shirohige documents.
    // All volume kinds (prose, workbook, presentation, template) route here
    // once documents are linked. The VolumeDocumentEditor handles the empty
    // state with a "Create Document" affordance.
    return /*#__PURE__*/ _jsx(VolumeDocumentEditor, {
        projectId: id,
        volume: volume
    });
}
